module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-2024f121.png";